import type { FC } from 'react';
import type { BreakdownItem } from './licenseBreakdownData';

export type BreakdownLegendProps = {
  items: BreakdownItem[];
};

/**
 * Legend of a breakdown chart, doubling as its data table: swatch, label, count and the share of the
 * category. Colours come from the same palette entries as the chart slices, so the two cannot drift.
 */
export const BreakdownLegend: FC<BreakdownLegendProps> = ({ items }) => (
  <ul className='flex list-none flex-col gap-3xs p-none'>
    {items.map((item) => (
      <li key={item.label} className='flex items-center gap-xs text-default'>
        <span
          className='h-3 w-3 shrink-0 rounded-sm'
          style={{ backgroundColor: item.color }}
        />
        <span className='min-w-0 truncate'>{item.label}</span>
        <span className='ml-auto shrink-0 font-semibold'>
          {item.count.toLocaleString()}
        </span>
        <span className='w-10 shrink-0 text-right text-plain text-sm'>
          {`${Math.round(item.proportion)}%`}
        </span>
      </li>
    ))}
  </ul>
);
